import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "news-feed",
  name: "资讯流",
  icon: "讯",
  group: "资讯门户",
  description: "按频道展示公开发布的图文资讯",
  defaultProps: {
    "channels": "推荐,本地,热点,文旅,民生,视频",
    "defaultChannel": "推荐",
    "pageSize": 20,
    "layoutMode": "WATERFALL",
    "emptyText": "暂时没有更多资讯",
    "showSummary": true,
    "showCover": true,
    "showSource": true,
    "showPublishedAt": true
}
}
